import { SaveRecordAction } from '@aibees/elephant/hooks';
import { useCanReverifyEmail } from '@aibees/elephant/hooks/use-can-reverify-email';
import { useMemo } from 'react';
import { config } from '../config';
import { useDefaultFileName } from './use-default-file-name';

export function useExportDefaultValues() {
  const defaultFileName = useDefaultFileName();
  // Same gate the Email Re-Verify row uses, so a row the user never sees can't
  // still ship in the request payload.
  const canReverifyEmail = useCanReverifyEmail();

  return useMemo(() => {
    const { defaultValues } = config;
    const values = { ...defaultValues };

    values.name = defaultFileName;

    // Remove EMAIL_REVERIFY completely when re-verify doesn't apply to this flow
    if (!canReverifyEmail) {
      delete values[SaveRecordAction.CONTACT_REVERIFY_EMAIL];
    }

    return values;
  }, [canReverifyEmail, defaultFileName]);
}
